module.exports = __webpack_public_path__ + "img/tp-12.df413fa0.png";